import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c6f992f8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alipay-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const _hoisted_3 = {
  class: "flex-list",
  style: {
    "justify-content": "flex-start"
  }
};
const _hoisted_4 = {
  class: "notice-text"
};
const _hoisted_5 = {
  class: "notice-desc"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://ewe8txd9jt.feishu.cn/sheets/shtcnFl01iQTMCceH3uiGv3mEVc?sheet=f6CglY"
}, " 《域名隔离表》 ", -1));
const __default__ = {
  name: 'AliMiniGame'
};
import SvgIcon from '@/components/SvgIcon.vue';
import { copy } from '@/common';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm', 'setVisible'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const aliminigameRef = ref(null); // 支付宝app支付ref
    const aliminigameForm = reactive({
      channelRate: 0.01,
      appId: '',
      pkg: '',
      mchId: null,
      publicKey: '',
      appPublicKey: '',
      appPrivateKey: '',
      appGateway: 'https://pay.wedobest.com.cn:8449/PayServer/pay/aliminigame/callback',
      mchName: '',
      pkgList: [{
        pkg: ''
      }]
    }); // 支付宝app支付
    const channelRateList = ref([]); // 费率列表
    const validateForm = () => {
      var _aliminigameRef$value;
      (_aliminigameRef$value = aliminigameRef.value) === null || _aliminigameRef$value === void 0 || _aliminigameRef$value.validate().then(() => {
        emit('submitForm', aliminigameForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        aliminigameForm.appId = n.appId;
        aliminigameForm.pkg = n.pkg;
        aliminigameForm.mchName = n.mchName;
        aliminigameForm.publicKey = n.publicKey;
        aliminigameForm.appPublicKey = n.appPublicKey;
        aliminigameForm.appPrivateKey = n.appPrivateKey;
        channelRateList.value = n.channelRateList;
        aliminigameForm.channelRate = n.channelRate;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: aliminigameForm,
        ref_key: "aliminigameRef",
        ref: aliminigameRef,
        rules: __props.rules,
        name: "alipay-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: aliminigameForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => aliminigameForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "mchName",
          label: "商户主体："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: aliminigameForm.mchName,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => aliminigameForm.mchName = $event),
            disabled: "",
            maxlength: 200
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "channelRate",
          label: "费率："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: aliminigameForm.channelRate,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => aliminigameForm.channelRate = $event),
            options: channelRateList.value
          }, null, 8, ["value", "options"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createTextVNode("使用支付宝支付功能将收取1%手续费")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "questionMark",
              "class-name": "question-icon"
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "AppID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: aliminigameForm.appId,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => aliminigameForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "publicKey",
          label: "支付宝公钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            value: aliminigameForm.publicKey,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => aliminigameForm.publicKey = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appPublicKey",
          label: "应用公钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            value: aliminigameForm.appPublicKey,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => aliminigameForm.appPublicKey = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appPrivateKey",
          label: "应用私钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            value: aliminigameForm.appPrivateKey,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => aliminigameForm.appPrivateKey = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appGateway",
          label: "应用网关："
        }, {
          default: _withCtx(() => {
            var _aliminigameForm$appG, _aliminigameForm$appG2;
            return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(" https:// "), _createElementVNode("span", null, _toDisplayString((_aliminigameForm$appG = aliminigameForm.appGateway) === null || _aliminigameForm$appG === void 0 || (_aliminigameForm$appG = _aliminigameForm$appG.split('https://')[1]) === null || _aliminigameForm$appG === void 0 ? void 0 : _aliminigameForm$appG.split('/PayServer')[0]), 1), _createTextVNode(" " + _toDisplayString('/PayServer' + ((_aliminigameForm$appG2 = aliminigameForm.appGateway) === null || _aliminigameForm$appG2 === void 0 ? void 0 : _aliminigameForm$appG2.split('PayServer')[1])), 1)]), _createVNode(_component_a_tooltip, null, {
              title: _withCtx(() => [_createTextVNode("复制")]),
              default: _withCtx(() => [_createVNode(SvgIcon, {
                "icon-class": "copy",
                "class-name": "copy-icon",
                onClick: _cache[7] || (_cache[7] = $event => _unref(copy)(aliminigameForm.appGateway))
              })]),
              _: 1
            })]), _createElementVNode("div", _hoisted_5, [_createTextVNode(" 请复制该链接，按 "), _hoisted_6, _createTextVNode(" 中 pay 业务名对应的域名，替换链接标红部分；并配置到支付宝开放平台-开发设置-应用网关处; "), _createVNode(_component_a_button, {
              class: "img-btn",
              type: "link",
              onClick: _cache[8] || (_cache[8] = $event => emit('setVisible', true))
            }, {
              default: _withCtx(() => [_createTextVNode("图片指引")]),
              _: 1
            })])];
          }),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});